import i18n from "../../../../constants/i18n";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import ET3Circle from "../../../../core/et3-circle";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const SelectAll = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isSelectedAll = getKhattabatSelectsStore().isSelectedAll("clientPage");

  return (
    <ET3Div
      width={200}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Circle
        size={20}
        style={{
          border: `2px solid ${colors.all.dimGray}`,
          backgroundColor: isSelectedAll
            ? colors.all.green
            : colors.all.transparent,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer"
        }}
        color={""}
        withShadow={true}
        onClick={() => {
          getKhattabatSelectsStore().toggleAllMarksStates("clientPage");
        }}
      />

      <Et3Margin top={0} bottom={0} left={5} right={0} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={25}
        isSpan={true}
        text={i18n.get("SELECT_ALL")}
        style={{}}
        color={""}
      />
    </ET3Div>
  );
});

export default SelectAll;
